import * as React from 'react';
import { useDispatch } from 'react-redux';
import {
  Box,
  Grid, Paper,
  Tabs, Tab,
} from '@mui/material';
import {
  useMember,
  getOneMemberAction, uploadAction, updateMemberAction
} from '@ivymobi/orbit-core/business/tenant';

import { TabPanel } from '../components';
import VcardEdit, { VcardEditProps } from './vcardEdit';
import EmailTemplate, { EmailTemplateProps } from './emailTemplate';
import { UserContext, TenantContext } from '../orbit-context';
import Loader from '../components/loaders';

type Mode = 'vcard' | 'email';
export interface MyProps extends VcardEditProps, EmailTemplateProps {
  mode: Mode;
  onModeChange: (e: React.ChangeEvent<HTMLInputElement>, newValue) => void;
}
export function My(props: MyProps) {
  const { mode, onModeChange, doUploadAsset, ...rest } = props;

  return (
    <Paper elevation={0} style={{ flexGrow: 1 }}>
      <Grid container spacing={1} >
        {/* <Grid item xs={12}>
          <Tabs indicatorColor="primary"
            value={mode} onChange={onModeChange}
          >
            <Tab label="编辑名片" value="vcard" />
            <Tab label="邮件模板" value="email" />
          </Tabs>
        </Grid> */}
        <Box p={4} width="100%" maxWidth="520px">
          <TabPanel id="vcard" value={mode} >
            <VcardEdit {...rest} doUploadAsset={doUploadAsset} />
          </TabPanel>
          <TabPanel id="email" value={mode} >
            <EmailTemplate {...rest} />
          </TabPanel>
        </Box>
      </Grid>
    </Paper>
  );
}

export default function MyContainer () {
  const [mode, setMode] = React.useState<Mode>('vcard');
  const dispatch = useDispatch();
  const user = React.useContext(UserContext);
  const tenant = React.useContext(TenantContext);

  const member = useMember(user.user, tenant, user.user.id);
  React.useEffect(() => {
    dispatch(getOneMemberAction({user, tenant, payload: {id: user.user.id}}));
  }, [dispatch, user, tenant]);

  const doUploadAsset = React.useCallback((file: File) => {
    return dispatch(uploadAction({user, tenant, payload: file}));
  }, [dispatch, user, tenant]);

  const updateMember = React.useCallback((data) => {
    dispatch(updateMemberAction({user, tenant, memberId: member.id, data}));
  }, [dispatch, user, tenant]);

  const onModeChange = (event, newValue) => setMode(newValue);

  if (!member) {
    return <Loader />
  }

  return (
    <My
      onSubmit={updateMember}
      mode={mode}
      onModeChange={onModeChange}
      tenant={tenant}
      member={member}
      doUploadAsset={doUploadAsset}
    />
  );
}